export const accessories = (state = [], action) => {
  if (action.type === 'FETCH_ACCESSORIES') {
    return action.payload;
  }
  if (action.type === 'CLEAR_ACCESSORIES') {
    return [];
  }
  return state;
};

export const accessory = (state = {}, action) => {
  if (action.type === 'FETCH_ACCESSORY') {
    return action.payload;
  }
  if (action.type === 'CLEAR_ACCESSORY') {
    return {};
  }
  return state;
};
